import HeroSection from './components/HeroSection';
import { useProductContext } from './context/product-context';

const About = () => {

  const {myName} = useProductContext();

  const data= {
    name: 'Anas Ecommerce'
  }

  return (
    <>
      {myName}
      <HeroSection myData={data}/>
    </>
  )
}

export default About